export const API_URL = process.env.VUE_APP_API_URL;
export const BASE_URL = process.env.VUE_APP_BASE_URL;

export const REMOTE_URL = process.env.VUE_APP_REMOTE_URL;

export const TOKEN = "FUJI_ACCTG_TOKEN";

export const TRANSACTION_STATUSES = {
    "draft": "Draft",
    "approved": "Approved",
    "submitted": "Submitted",
    "noted": "Noted",
    "partial_noted": "Partially Noted",
    "received": "Received",
    "returned": "Returned",
    "cancelled": "Cancelled",
    "sent": "For Accounting Review",
}

export const ERROR_FIELD = 2;
export const INITIAL_FIELD = 0;
export const SUCCESS_FIELD = 1;

export const FIELD_STATUS_BOOTSTRAP_BASE = {
    0: "",
    1: "is-valid",
    2: "is-invalid"
}

export const FIELD_STATUS_BASE = {
    0: "",
    1: "valid",
    2: "invalid"
}

export const FILE_EXTENSIONS = {
    image : ['apng', 'png', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
    video : ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
    excel : ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
    word : ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx']
}

export const ERROR_MESSAGES = {
    required_fields: 'Please fill in required fields.'
}

export const RFPStatusFormat = {
    draft: {
        class: 'bg-secondary-subtle',
        icon: ['far', 'pen-to-square']
    },
    submitted: {
        class: 'bg-warning-subtle',
        icon: ['fas', 'paper-plane']
    },
    noted: {
        class: 'bg-info-subtle',
        icon: ['fas', 'signature']
    },
    partial_noted: {
        class: 'bg-info-subtle',
        icon: ['fas', 'signature']
    },
    approved: {
        class: 'bg-success-subtle',
        icon: ['fas', 'check']
    },
    cancelled: {
        class: 'bg-danger-subtle',
        icon: ['fas', 'ban']
    },
    received: {
        class: 'bg-primary-subtle',
        icon: ['fas', 'arrow-right-to-bracket']
    },
    returned: {
        class: 'bg-danger',
        icon: ['fas', 'rotate-left'],
        icon_class: 'text-light'
    },
    sent: {
        class: 'bg-success',
        icon: ['fas', 'paper-plane']
    }
}

export const MODULE_MAPPING = {
    dashboard: {
        code: 'dashboard',
        name: 'Dashboard',
        link: 'dashboard'
    },
    requestForPayment: {
        code: 'rfp',
        name: 'Request for Payment',
        link: 'requestForPayment'
    },
    signatories: {
        code: 'signatories',
        name: 'Signatories',
        link: 'signatories'
    },
    users: {
        code: 'users',
        name: 'Users',
        link: 'users'
    }
}

export const MODULES = {
    dashboard: {
        code: 'dashboard',
        name: 'Dashboard',
        link: 'dashboard'
    },
    rfp: {
        code: 'rfp',
        name: 'Request for Payment',
        link: 'requestForPayment'
    },
    signatories: {
        code: 'signatories',
        name: 'Signatories',
        link: 'signatories'
    },
    users: {
        code: 'users',
        name: 'Users',
        link: 'users'
    },
}

export const ACTION_TEXT = {
    dashboard: {
        module: "Is Accessible"
    },
    rfp: {
        module: "Is Accessible",
        view: "View",
        view_all: "View All Requests",
        view_department: "View Department/s Request",
        view_branch: "View Branch/s Request",
        view_specific: "View per department and branches",
        create: "Create Request",
        update: "Modify Request",
        note: "Sign Request",
        approve: "Approve Request",
        cancel: "Cancel Request"
    },
    users: {
        module: "Is Accessible",
        view: "View Users",
        create: "Add New User",
        update: "Modify User Details",
        reset: "Reset Password",
        permission: "Modify User Permissions"
    },
    signatories: {
        module: "Is Accessible",
        view: "View Signatories",
        create: "Add Signatories",
        update: "Modify Signatory Details",
        delete: "Delete Signatories"
    }
}

export const RFP_KEY_EQUIVALENTS = {
    code: '',
    date_needed: 'Date Needed',
    rfp_no: 'RFP No.',
    department: 'Department',
    branch: 'Branch',
    status: 'draft',
    payee: 'Payee',
    isNewPayee: 'Is new payee',
    tin: 'TIN',
    payee_address: 'Address',
    vatType: 'VAT Type',
    wtax: 'gross',
    particulars: 'Particulars',
    mop: 'Mode of Payment',
    currency: 'Currency',
    amount: 'Amount',
    invoice_no: 'Invoice No.',
    po_no: 'P.O. No.',
    pr_no: 'P.R. No.',
    remarks: 'Remarks',
    reference: 'Reference',
    bank_mode: 'Bank Transaction Type',
    bank: 'Bank',
    bank_acc_no: 'Bank Account No.',
    bank_acc_name: 'Bank Name',
    swift_code: 'Swift code',
    subscriber_name: 'Subscriber',
    subscriber_no: 'Subscriber No.',
    noted_signatories: 'Persons to sign',
    approvers: 'Approvers',
    files: 'Files'
}

export const FILE_ICON_DISPLAY = {
    image : ['apng', 'png', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'],
    video : ['mkv', 'flv', 'vob', 'ogg', 'drc', 'avi', 'wmv', 'avchd', 'flv', 'mp4'],
    excel : ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xml', 'xlam', 'xla', 'xlw', 'xlr'],
    word : ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx'],
    pdf: ['pdf']
}

export const FILE_ICON_CONFIG = {
    image: {
        icon: ['fas', 'image'],
        color: '#eb8034'
    },
    video: {
        icon: ['fas', 'film'],
        color: '#3fb1d4'
    },
    word: {
        icon: ['fas', 'file-word'],
        color: 'blue'
    },
    excel: {
        icon: ['fas', 'file-excel'],
        color: 'green'
    },
    pdf: {
        icon: ['fas', 'file-pdf'],
        color: 'red'
    },
}

export const COLOR_PALETTE = ['(232, 228, 16', '(221, 102, 17', '(63, 187, 178', '(68, 204, 255',
    '(42, 82, 190', '(29, 77, 160', '(255, 111, 252', '(97, 102, 105', '(238, 221, 130', '(215, 211, 166',
    '(173, 198, 211', '(237, 184, 199', '(192, 216, 235', '(221, 218, 206', '(244, 235, 188', '(244, 216, 198',
    '(232, 228, 16', '(221, 102, 17', '(63, 187, 178', '(68, 204, 255', '(42, 82, 190', '(29, 77, 160',
    '(255, 111, 252', '(97, 102, 105', '(238, 221, 130', '(215, 211, 166', '(173, 198, 211', '(237, 184, 199',
    '(192, 216, 235', '(221, 218, 206', '(244, 235, 188', '(244, 216, 198']
